module.exports = {
	"title": "Claire Messud",
	"authorFirstName": "Claire",
	"authorLastName": "Messud",
	"social": {
		"socialLinksTitle": "Follow",
		"socialMediaLinks": [
			{
				"url": "https://www.facebook.com/clairemessud",
				"title": "Facebook",
				"type": "facebook"
			}
		]
	},
	"header": [
		{
			"id": "cccc5db3a0e9274842ac",
			"ref": "node://ae0524d751e44c43bcfa/8dcde75843c993c2ca1d/83ffc715b420fa652c2c/cccc5db3a0e9274842ac",
			"title": "Home",
			"qname": "o:cccc5db3a0e9274842ac",
			"typeQName": "nortoncore:home"
		},
		{
			"id": "55d3184882a0c6bc2dca",
			"ref": "node://ae0524d751e44c43bcfa/8dcde75843c993c2ca1d/83ffc715b420fa652c2c/55d3184882a0c6bc2dca",
			"title": "About",
			"qname": "o:55d3184882a0c6bc2dca",
			"typeQName": "nortoncore:aboutpage"
		},
		{
			"id": "7bcbc0e5e59d809ba24a",
			"ref": "node://ae0524d751e44c43bcfa/8dcde75843c993c2ca1d/83ffc715b420fa652c2c/7bcbc0e5e59d809ba24a",
			"title": "Books",
			"qname": "o:7bcbc0e5e59d809ba24a",
			"typeQName": "nortoncore:bookspage"
		},
		{
			"id": "881d3e259a4a23ebfb7d",
			"ref": "node://ae0524d751e44c43bcfa/8dcde75843c993c2ca1d/83ffc715b420fa652c2c/881d3e259a4a23ebfb7d",
			"title": "Articles",
			"qname": "o:881d3e259a4a23ebfb7d",
			"typeQName": "nortoncore:articles"
		},
		{
			"id": "bd7ea19caa1f6e875bec",
			"ref": "node://ae0524d751e44c43bcfa/8dcde75843c993c2ca1d/83ffc715b420fa652c2c/bd7ea19caa1f6e875bec",
			"title": "Contacts",
			"qname": "o:bd7ea19caa1f6e875bec",
			"typeQName": "nortoncore:contact"
		}
	],
	"newsletter": {
		"showNewsletter": true,
		"signUpTitleText": "Sign up for Newsletter",
		"signUpButtonText": "Sign up",
		"signUpPlaceholder": "Enter Your Email Address",
		"signupSuccessMessage": "Thank you for signing up!",
		"signupFailureMessage": "Sorry, your email is invalid. Please try again."
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/jsondata/siteConfig.json
// module id = 510
// module chunks = 0